import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=66862a32&scoped=true&"
var script = {}
import style0 from "./blank.vue?vue&type=style&index=0&id=66862a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66862a32",
  null
  
)

export default component.exports